import axios from 'axios';
import React, { useState } from 'react'
import ENDPOINT from '../../context/EndPoint';
import { CodeOffSharp } from '@mui/icons-material';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import SecurityHeaders from '../../context/SecurityHeaders';
import { Avatar } from '@mui/material';
import { useDispatch } from 'react-redux';

const AddStudent = () => {
    const dispatch = useDispatch()
    const [companyLogo, setCompanyLogo] = useState(null);
const [companyPreview, setCompanyPreview] = useState(null);
    

    const [imagePreview, setImagePreview] = useState(null);

    const handleCompanyLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCompanyLogo(file);
            setCompanyPreview(URL.createObjectURL(file));
        }
    };

    const [formData, setFormData] = useState({
        full_name: '',
        package: '',
        role: '',
        company: '',
        image: null,
        companyLogo: null
    }
    )
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({
                ...formData,
                image: file
            });
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {
            dispatch({ type: 'LOADING' })
            if (!formData.image || !companyLogo) {
                alert("Both student image and company logo are required.");
                return;
            }



              const data = new FormData();
              data.append("full_name", formData.full_name);
              data.append("package", formData.package);
              data.append("role", formData.role);
              data.append("company", formData.company);
              data.append("image", formData.image);
              data.append("company_logo", companyLogo);
              
              const response = await axios.post(
                ENDPOINT + "add-student-placement-data.php",
                data
              );

            if (response.data.status === 'success') {
                dispatch({ type: 'DONE_LOADING' })
                console.log('Student placement details uploaded successfully:', response);
                window.location.replace('/placement_students')
            }
            else {
                dispatch(({ type: 'ERROR', payload: 'Error savingStudentPlacement' }))
            }

        }
        catch (error) {
            dispatch({ type: 'ERROR', payload: error.message })
        }
    };



    return (

        <Container className="mt-3 ">
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6}>
                    <div className="p-4 shadow rounded bg-light">
                        <h3 className="text-center mb-4">Upload Placed Student Details</h3>
                        <Form onSubmit={handleSubmit}>

                            {imagePreview && (
                                <div className="mb-2">
                                    <p>Image Preview:</p>
                                    <Avatar

                                        src={imagePreview}
                                        alt="Preview"
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </div>
                            )}

                            <Form.Group className="mb-2">
                                <Form.Label>Upload Image</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="image"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                            </Form.Group>

                            {/* Company Logo Preview */}
{companyPreview && (
    <div className="mb-2">
        <p>Company Logo Preview:</p>
        <Avatar
            src={companyPreview}
            style={{
                width: '100px',
                height: '100px',
                objectFit: 'contain'
            }}
        />
    </div>
)}

<Form.Group className="mb-2">
    <Form.Label>Upload Company Logo</Form.Label>
    <Form.Control
        type="file"
        accept="image/*"
        onChange={handleCompanyLogoChange}
    />
</Form.Group>



                            <Form.Group className="mb-2">
                                <Form.Label>Full Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="full_name"
                                    value={formData.full_name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-2">
                                <Form.Label>Package</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="package"
                                    value={formData.package}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-2">
                                <Form.Label>role</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="role"
                                    value={formData.role}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>


                            <Form.Group className="mb-2">
                                <Form.Label>Company</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>


                            <Button type="submit" className="btn ">
                                Upload
                            </Button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default AddStudent